import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as products from '@webapp/sdk/products';
import { Actions } from '../../actions';
import {
  GetProducts,
  GetProductsError,
  GetProductsSuccess,
} from '../action-creators';
import { GET_PRODUCTS } from '../actions';
import { Product } from '@services/product/types/product';
import { Coupon } from '@services/product/types/coupon';

export const getProductsEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, GetProducts>(GET_PRODUCTS),
    mergeMap(async () => {
      try {
        let productList: Product[] = [];
        let coupons: Coupon[] = [];

        const [productsSettled, couponsSettled] = await Promise.allSettled([
          products.list(),
          products.listCoupons(),
        ]);

        if (productsSettled.status === 'fulfilled') {
          productList = productsSettled.value;
        }

        if (couponsSettled.status === 'fulfilled') {
          coupons = couponsSettled.value;
        }
        return new GetProductsSuccess(productList, coupons);
      } catch (err) {
        return new GetProductsError(err.message);
      }
    })
  );
